"use client";
import React from "react";

type Props = object;

function SomaFooter({}: Props) {
  return (
    <footer className="border-t border-white/15 px-4 py-8 md:px-6 lg:px-8">
      <div className="mx-auto w-full max-w-6xl">
        <div className="flex flex-col items-center justify-between gap-4 md:flex-row">
          <div className="text-sm text-zinc-400">
            Released under the{" "}
            <span
              className="font-medium"
              style={{
                background:
                  "linear-gradient(135deg, #FCFCFC 0%, #A0A0A0 50%, #505050 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
              }}
            >
              MIT License
            </span>
            .
          </div>
          <div className="flex flex-row gap-6 text-sm">
            <button className="text-zinc-400 transition-colors duration-200 hover:text-zinc-200">
              Terms of Service
            </button>
            <button className="text-zinc-400 transition-colors duration-200 hover:text-zinc-200">
              Privacy Policy
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default SomaFooter;
